import {
  AmplitudeScript,
  GoogleTagManagerScript,
  HotjarScript,
  LeanScript,
} from './external-scripts.model';
import { PrypcoEnv } from './prypco-env.model';

export interface Environment extends PrypcoEnv {
  production: boolean;
  noIndex: boolean;
  testing: boolean;
  dev: boolean;
  featureFlags: FeatureFlags;
  identifiers: Partial<Record<EnvironmentIdentifier, string>>;
  externalScripts: {
    amplitude: AmplitudeScript;
    googleTagManager: GoogleTagManagerScript[];
    hotjar: HotjarScript;
    lean: LeanScript;
    gtm: boolean;
    intercom: boolean;
  };
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
}

interface FeatureFlags {
  blocks: {
    backOffice: boolean;
    devPanel: boolean;
    payByCard: boolean;
    payInstantTransfer: boolean;
    tapSDKId: string;
    portal: boolean;
    comingSoon: boolean;
  };
}

export enum EnvironmentIdentifier {
  MapBoxKey = 'MAP_BOX_KEY',
  LeanKey = 'LEAN_KEY',
}

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

export interface AuthState {
  remoteConfig: Record<string, any>;
}
